import * as $ from 'jquery';

$(() => {
	if ($('body.cq_isAuthorInstance.h1Warning').length) {
		$(document).on('h1-warning-show', function() {
			$('.mod-menu, .mod-meta, .mod-article, .meta-datacontainer-emagazinearticle').addClass('h1-warning');
		});
		$(document).on('h1-warning-hide', function() {
			$('.mod-menu, .mod-meta, .mod-article, .meta-datacontainer-emagazinearticle').removeClass('h1-warning');
		});
	}
});



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/emag/dialogue/seo-utils.ts